import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import { KeyEventUtil } from 'utils'

import * as TablasComunesService from 'services/tablasComunes.service'

const SerieDocumentoFormGroup = ({
  iError,
  iTouched,
  fIsSubmitting,
  setFieldValue,
  handleChange
}) => {
  const [seriesAduana, setSeriesAduana] = React.useState([])

  React.useEffect(() => {
    TablasComunesService.getAsSelect(TiposTablaComunConstant.ADUANAS).then(({ data }) => {
      setSeriesAduana(data)
    })
  }, [])

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-numeroDocumento', e)
  }, [])

  const onChange = React.useCallback(
    e => {
      handleChange(e)

      const nuevoValor = e.target.value
      setFieldValue('codigoAduana', nuevoValor)
    },
    [setFieldValue, handleChange]
  )

  return (
    <Form.Group>
      <Form.Label text='SERIE' md={4} htmlFor='input-serieDocumento' alignRightAt='md' />
      <Col md={8}>
        <Field name='serieDocumento'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='input-serieDocumento'
              onChange={onChange}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            >
              <option value=''>Seleccionar</option>
              {seriesAduana.map((x, k) => (
                <option key={k} value={x._id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SerieDocumentoFormGroup)
